import React from "react";
import PhoneInput from "react-phone-number-input";

const PhoneInputComponent = ({
  validationMessage,
  handlePhoneInputChange,
  value,
  labelName,
  labelFor,
  containerStyles,
  inputClassName,
  ...props
}) => {
  return (
    <div className={`${containerStyles} flex flex-col gap-2`}>
      {labelName && (
        <label className="text-sm font-medium text-gray-700" htmlFor={labelFor}>
          {labelName}
        </label>
      )}
      <div className="w-full modern-phone-input">
        <PhoneInput
          value={value}
          onChange={handlePhoneInputChange}
          className={inputClassName}
          {...props}
        />
        {validationMessage && (
          <div className="flex items-center gap-2 text-red-600 text-sm mt-2">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            <span>{validationMessage}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PhoneInputComponent;
